var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modalDuplicationCommande",
      attrs: {
        size: "md",
        title: "Dupliquer une commande",
        "ok-title": "Dupliquer",
        "ok-disabled":
          !_vm.$v.optionsDuplication.nom.required ||
          !_vm.$v.optionsDuplication.nom.minLength ||
          !_vm.$v.optionsDuplication.dateLivraisonDebut.required,
        "cancel-title": "Annuler",
        "no-close-on-backdrop": ""
      },
      on: {
        show: function($event) {
          return _vm.initialiserModale()
        },
        shown: function($event) {
          return _vm.$refs.nomNouvelleCommande.focus()
        },
        ok: function($event) {
          return _vm.dupliquerCommande()
        }
      }
    },
    [
      _c("template", { slot: "default" }, [
        _c("div", { staticClass: "form-group" }, [
          _c("label", { attrs: { for: "nomNouvelleCommande" } }, [
            _vm._v("Nom de la nouvelle commande")
          ]),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.trim",
                value: _vm.optionsDuplication.nom,
                expression: "optionsDuplication.nom",
                modifiers: { trim: true }
              }
            ],
            ref: "nomNouvelleCommande",
            staticClass: "container-fluid",
            attrs: { type: "text", id: "nomNouvelleCommande", maxlength: "80" },
            domProps: { value: _vm.optionsDuplication.nom },
            on: {
              focus: function($event) {
                return $event.target.select()
              },
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.optionsDuplication,
                  "nom",
                  $event.target.value.trim()
                )
              },
              blur: function($event) {
                return _vm.$forceUpdate()
              }
            }
          }),
          !_vm.$v.optionsDuplication.nom.required
            ? _c("div", { staticClass: "error" }, [
                _vm._v("Ce champ est requis")
              ])
            : _vm._e(),
          !_vm.$v.optionsDuplication.nom.minLength
            ? _c("div", { staticClass: "error" }, [
                _vm._v("Ce champ doit contenir au moins 3 caractères")
              ])
            : _vm._e()
        ]),
        _c(
          "div",
          { staticClass: "form-group" },
          [
            _c("label", { attrs: { for: "dpDateLivraisonDebut" } }, [
              _vm._v("Livraisons souhaitées à partir du...")
            ]),
            _c("v-date-picker", {
              staticClass: "date-picker",
              attrs: {
                id: "dpDateLivraisonDebut",
                popover: { visibility: "click" }
              },
              on: {
                input: function($event) {
                  _vm.optionsDuplication.dateLivraisonDebut = $event
                }
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(ref) {
                    var inputValue = ref.inputValue
                    var inputEvents = ref.inputEvents
                    return [
                      _c(
                        "input",
                        _vm._g(
                          {
                            domProps: {
                              value: inputValue
                                ? inputValue
                                : "Livraisons souhaitées à partir du..."
                            }
                          },
                          inputEvents
                        )
                      )
                    ]
                  }
                }
              ]),
              model: {
                value: _vm.optionsDuplication.dateLivraisonDebut,
                callback: function($$v) {
                  _vm.$set(_vm.optionsDuplication, "dateLivraisonDebut", $$v)
                },
                expression: "optionsDuplication.dateLivraisonDebut"
              }
            }),
            !_vm.$v.optionsDuplication.dateLivraisonDebut.required
              ? _c("div", { staticClass: "error" }, [
                  _vm._v("Ce champ est requis")
                ])
              : _vm._e()
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "form-group" },
          [
            _c("label", { attrs: { for: "selEtablissement" } }, [
              _vm._v("Vers établissement")
            ]),
            _c("v-select", {
              attrs: {
                id: "selEtablissement",
                options: _vm.optionsEtablissements,
                value: "eId",
                label: "eRS",
                placeholder: "Établissements...",
                clearable: false
              },
              on: {
                input: function($event) {
                  _vm.optionsDuplication.nouvelEtablissementId =
                    _vm.etablissementSelectionne.eId
                }
              },
              model: {
                value: _vm.etablissementSelectionne,
                callback: function($$v) {
                  _vm.etablissementSelectionne = $$v
                },
                expression: "etablissementSelectionne"
              }
            })
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }